import BliIconSiAnalytics from '@blibli/blue-dls-library-icon/dist/Analytics'
import BliIconSiHome from '@blibli/blue-dls-library-icon/dist/Home'
import BliIconSiMission from '@blibli/blue-dls-library-icon/dist/Mission'
import BliIconSiPeopleProfile from '@blibli/blue-dls-library-icon/dist/PeopleProfile'
import BliIconSiWallet from '@blibli/blue-dls-library-icon/dist/Wallet'
import { mapActions, mapState } from 'pinia'

import { app, pages } from '@/config/index.js'
import { useCommonStore } from '@/stores/common.js'
import { useMemberStore } from '@/stores/member.js'
import { useMissionStore } from '@/stores/mission.js'
import asyncTracker from '@/trackers/async-tracker.js'
import { isApp } from '@/utils/browser.js'
import { valueOrDefault } from '@/utils/common.js'
import { currentTimeMillis, formatDateYYYYMMDD } from '@/utils/date.js'
import { hasFeatureFlag } from '@/utils/feature-switch.js'
import { getLocalStorageData, setLocalStorageData } from '@/utils/storage.js'

const MISSION = 'MISSION'
const PAGE_SIZE = 9
const CURRENT_PAGE = 1
const IN_PROGRESS = 'ON_GOING_DELAYED_REWARD'
const AFFILIATE = 'affiliate'

export default {
  name: 'Menu',
  components: {
    BliIconSiHome,
    BliIconSiAnalytics,
    BliIconSiWallet,
    BliIconSiPeopleProfile,
    BliIconSiMission
  },
  data () {
    return {
      originScreenMap: {
        [pages.home]: app.tracker.originScreen.home,
        [pages.performance]: app.tracker.originScreen.performance,
        [pages.wallet]: app.tracker.originScreen.wallet,
        [pages.setting]: app.tracker.originScreen.setting
      },
      componentMap: {
        [pages.home]: app.tracker.home,
        [pages.performance]: app.tracker.performance,
        [pages.wallet]: app.tracker.wallet,
        [pages.setting]: app.tracker.setting
      },
      today: formatDateYYYYMMDD(currentTimeMillis()),
      missionSeenDate: valueOrDefault(this.getMissionFeatureLocalStorage().clickMissionDate, null)
    }
  },
  computed: {
    ...mapState(useMemberStore, ['member']),
    ...mapState(useCommonStore, ['missionConfigs']),
    ...mapState(useMissionStore, ['newMissionAvailable']),
    menuList () {
      const menus = [
        {
          text: 'Eksplor',
          active: false,
          path: pages.home,
          icon: BliIconSiHome,
          show: true
        },
        {
          text: 'Performa',
          active: false,
          path: pages.performance,
          icon: BliIconSiAnalytics,
          show: true
        },
        {
          text: 'Mission',
          active: false,
          path: pages.mission,
          icon: BliIconSiMission,
          show: this.shouldShowMissionTab,
          redDot: this.shouldShowRedDotOnMissionMenu
        },
        {
          text: 'Saldo',
          active: false,
          path: pages.wallet,
          icon: BliIconSiWallet,
          show: true
        },
        {
          text: 'Profil',
          active: false,
          path: pages.setting,
          icon: BliIconSiPeopleProfile,
          show: true
        }
      ]

      return menus.filter(menu => menu.show)
    },
    currentRoutePath () {
      return this.$route.path
    },
    isMissionEnabled () {
      return this.missionConfigs?.globalSwitch
    },
    shouldShowMissionTab () {
      return this.isMissionEnabled || hasFeatureFlag(this.member?.allowedFeatureFlags, MISSION)
    },
    shouldShowRedDotOnMissionMenu () {
      return this.newMissionAvailable && this.missionSeenDate !== this.today
    }
  },
  methods: {
    ...mapActions(useMissionStore, ['getMissionAvailability']),
    isApp,
    trackMenuClick (path) {
      asyncTracker.call('commonTracker', 'trackButtonClick', {
        origin_screen: this.originScreenMap[this.currentRoutePath],
        component: this.componentMap[path]
      })
    },
    getMissionFeatureLocalStorage () {
      return valueOrDefault(getLocalStorageData(app.localStorage.blibliTiketAffiliateFeature), {})
    },
    setMissionFeatureLocalStorage (data) {
      const existing = this.getMissionFeatureLocalStorage()
      setLocalStorageData(app.localStorage.blibliTiketAffiliateFeature, { ...existing, ...data })
    },
    markMissionSeenToday () {
      this.setMissionFeatureLocalStorage({ clickMissionDate: this.today })
      this.missionSeenDate = this.today
    },
    handleMenuClick (menu) {
      // If the clicked menu path is the same as current route, do nothing
      if (this.currentRoutePath === menu.path) {
        return
      }
      this.$router.push(menu.path)

      this.trackMenuClick(menu.path)

      if (menu.path === pages.mission) {
        this.markMissionSeenToday()
      }
    },
    isMenuActive (path) {
      return this.currentRoutePath === path
    },
    init () {
      this.fetchMissions()
    },
    fetchMissions () {
      this.getMissionAvailability({
        queryParams: {
          page: CURRENT_PAGE,
          item_per_page: PAGE_SIZE,
          status: IN_PROGRESS,
          platform: AFFILIATE
        }
      })
    }
  },
  created () {
    this.init()
  }
}
